import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** PollSphere's cn(), unchanged. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
